'use client'
import React, { Fragment, useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { isMobile } from 'react-device-detect';
import Link from 'next/link';
import RadixTooltip from 'react-radix-tooltip';
import SvgIcons from "./SvgIcons";
import usePwaStatus from "@/helpers/usePwaStatus";
import "./Footer.css";


const { LinkedInIcon, GithubIcon, FacebookIcon, TwitchIcon, TikTokIcon, FlickrIcon, YoutubeIcon, InstagramIcon, XIcon, DiscordIcon, LinkExternalIcon, NpmIcon } = SvgIcons();

const rssFeeds = [
    '/projects',
    '/blog',
    '/skills-and-trainings',
    '/experience',
    '/work',
    '/education',
];

const Footer = () => {
    const [ startYear, setStartYear ] = useState<string>('2022');
    const [ hostname, setHostname ] = useState<string>('repulsivecoder.pro');
    const { isPWA } = usePwaStatus();
    const pathname = usePathname();

    useEffect(() => {
        if (window.location.hostname !== 'localhost') {
            setHostname(window.location.hostname);
            if (window.location.hostname === 'abdullahibnealam.com') {
                setStartYear('2024');
            } else if (window.location.hostname === 'repulsivecoder.com') {
                setStartYear('2009');
            }
        }
    }, []);

    if (isPWA) {
        return <></>;
    }

    return (
        <div className="footer">
            <div className="socialMedia">
                <RadixTooltip
                    title={<>
                        <div className="social-cards">
                            <img src='/media/AbdullahIbneAlam.webp' alt="Abdullah Ibne Alam"  />
                            <h1>Abdullah Ibne Alam</h1>
                            <p className="title">Solution Architect | Full-Stack | Mobile | IoT </p>
                            <p>Dhaka, Bangladesh</p>
                            <a href="https://www.linkedin.com/in/abdullah-ibne-alam/" className="connect-btn" target='_blank'>Connect <LinkExternalIcon width="18px" height="16px" /></a>
                        </div>
                    </>}
                    enableForMobile={true}
                >
                    <a href="https://www.linkedin.com/in/abdullah-ibne-alam/" title="Abdullah Ibne Alam - LinkedIn Profile" target="_blank" rel="noreferrer" className="linkedin" onClick={(e) => { if (isMobile) { e.preventDefault(); } }}>
                        <LinkedInIcon />
                    </a>
                </RadixTooltip>
                <RadixTooltip
                    title={<>
                        <div className="social-cards">
                            <img src='/media/RepulsiveCoder.webp' alt="Abdullah Ibne Alam"  />
                            <h1>RepulsiveCoder</h1>
                            <div className="top-repos">
                                <Link className="repo" href="https://github.com/RepulsiveCoder/react-carousel-photo-gallery" target="_blank">
                                    <h3>react-carousel-photo-gallery</h3>
                                    <p>npm install react-carousel-photo-gallery</p>
                                </Link>
                                <Link className="repo" href="https://github.com/RepulsiveCoder/react-animated-text-writer" target="_blank">
                                    <h3>react-animated-text-writer</h3>
                                    <p>npm install react-animated-text-writer</p>
                                </Link>
                                <Link className="repo" href="https://github.com/RepulsiveCoder/homecraft3d" target="_blank">
                                    <h3>homecraft3d</h3>
                                    <p>TypeScript, Babylon.js</p>
                                </Link>
                                <Link className="repo" href="https://github.com/RepulsiveCoder/retro-tone-player" target="_blank">
                                    <h3>retro-tone-player</h3>
                                    <p>Macromedia Flash MX & ActionScript </p>
                                </Link>
                            </div>
                            <a href="https://github.com/RepulsiveCoder/" className="connect-btn" target='_blank'>Connect <LinkExternalIcon width="18px" height="16px" /></a>
                        </div>
                    </>}
                    enableForMobile={true}
                >
                    <a href="https://github.com/RepulsiveCoder/" title="Abdullah Ibne Alam - Github" target="_blank" rel="noreferrer" className="github" onClick={(e) => { if (isMobile) { e.preventDefault(); } }}>
                        <GithubIcon />
                    </a>
                </RadixTooltip>
                <RadixTooltip
                    title={<>
                        <div className="social-cards">
                            <img src='/media/RepulsiveCoder_FB.webp' alt="Abdullah Ibne Alam"  />
                            <h1>Abdullah Ibne Alam</h1>
                            <p className="title">3.5K followers • 36 following</p>
                            <p>RCC 95-01</p>
                            <p>IUT 01 (02-05)</p>
                            <p>Banglalink 2010-23</p>
                            <p>Full Stack Web & Mobile App Developer</p>
                            <a href="https://www.facebook.com/RepulsiveCoder" className="connect-btn" target='_blank'>Connect <LinkExternalIcon width="18px" height="16px" /></a>
                        </div>
                    </>}
                    enableForMobile={true}
                >
                    <a href="https://www.facebook.com/RepulsiveCoder" title="Abdullah Ibne Alam - Facebook Profile" target="_blank" rel="noreferrer" className="facebook" onClick={(e) => { if (isMobile) { e.preventDefault(); } }}>
                        <FacebookIcon />
                    </a>
                </RadixTooltip>
                <RadixTooltip
                    title={<>
                        <div className="social-cards">
                            <img src='/media/RepulsiveCoder.webp' alt="Abdullah Ibne Alam"  />
                            <h1>RepulsiveCoder</h1>
                            <p className="title">30 followers</p>
                            <p>I stream Valorant live</p>
                            <a href="https://www.twitch.tv/RepulsiveCoder" className="connect-btn" target='_blank'>Connect <LinkExternalIcon width="18px" height="16px" /></a>
                        </div>
                    </>}
                    enableForMobile={true}
                >
                    <a href={!isMobile ? 'https://www.twitch.tv/RepulsiveCoder' : ''} title="Abdullah Ibne Alam - Twitch" target="_blank" rel="noreferrer" className="twitch" onClick={(e) => { if (isMobile) { e.preventDefault(); } }}>
                        <TwitchIcon />
                    </a>
                </RadixTooltip>
                <RadixTooltip
                    title={<>
                        <div className="social-cards">
                            <img src='/media/RepulsiveCoder_Tiktok.webp' alt="Abdullah Ibne Alam"  />
                            <h1>Abdullah Ibne Alam</h1>
                            <p className="title">24.5K Followers | 462 Following</p>
                            <p>Tiktok Effect Creator</p>
                            <p>Neko | Kedi</p>
                            <a href="https://www.tiktok.com/@repulsivecoder" className="connect-btn" target='_blank'>Connect <LinkExternalIcon width="18px" height="16px" /></a>
                        </div>
                    </>}
                    enableForMobile={true}
                >
                    <a href="https://www.tiktok.com/@repulsivecoder" title="Abdullah Ibne Alam - Tiktok" target="_blank" rel="noreferrer" className="tiktok" onClick={(e) => { if (isMobile) { e.preventDefault(); } }}>
                        <TikTokIcon />
                    </a>
                </RadixTooltip>
                <RadixTooltip
                    title={<>
                        <div className="social-cards">
                            <img src='/media/AbdullahIbneAlam.webp' alt="Abdullah Ibne Alam"  />
                            <h1>Abdullah Ibne Alam</h1>
                            <p className="title">30 subscribers • 111 videos</p>
                            <p>I stream Valorant live</p>
                            <a href="https://www.youtube.com/@RepulsiveCoder" className="connect-btn" target='_blank'>Connect <LinkExternalIcon width="18px" height="16px" /></a>
                        </div>
                    </>}
                    enableForMobile={true}
                >
                    <a href="https://youtube.com/@RepulsiveCoder" title="Abdullah Ibne Alam - Youtube" target="_blank" rel="noreferrer" className="youtube" onClick={(e) => { if (isMobile) { e.preventDefault(); } }}>
                        <YoutubeIcon />
                    </a>
                </RadixTooltip>
                <RadixTooltip
                    title={<>
                        <div className="social-cards">
                            <img src='/media/RepulsiveCoder_FB.webp' alt="Abdullah Ibne Alam"  />
                            <h1>Abdullah Ibne Alam</h1>
                            <p className="title">16 posts • 47 followers • 52 following</p>
                            <a href="https://www.instagram.com/RepulsiveCoder/" className="connect-btn" target='_blank'>Connect <LinkExternalIcon width="18px" height="16px" /></a>
                        </div>
                    </>}
                    enableForMobile={true}
                >
                    <a href="https://www.instagram.com/RepulsiveCoder/" title="Abdullah Ibne Alam - Instagram" target="_blank" rel="noreferrer" className="instagram" onClick={(e) => { if (isMobile) { e.preventDefault(); } }}>
                        <InstagramIcon />
                    </a>
                </RadixTooltip>
                <RadixTooltip
                    title={<>
                        <div className="social-cards">
                            <img src='/media/AbdullahIbneAlam.webp' alt="Abdullah Ibne Alam"  />
                            <h1>Abdullah Ibne Alam</h1>
                            <p className="title">22 Followers • 20 Following</p>
                            <a href="https://www.flickr.com/photos/repulsivecoder/" className="connect-btn" target='_blank'>Connect <LinkExternalIcon width="18px" height="16px" /></a>
                        </div>
                    </>}
                    enableForMobile={true}
                >
                    <a href="https://www.flickr.com/photos/repulsivecoder/" title="Abdullah Ibne Alam - Flickr" target="_blank" rel="noreferrer" className="flickr" onClick={(e) => { if (isMobile) { e.preventDefault(); } }}>
                        <FlickrIcon className="flickr" />
                    </a>
                </RadixTooltip>
                <RadixTooltip
                    title={<>
                        <div className="social-cards">
                            <img src='/media/AbdullahIbneAlam.webp' alt="Abdullah Ibne Alam"  />
                            <h1>Abdullah Ibne Alam</h1>
                            <p className="title">8 Following • 8 Followers</p>
                            <a href="https://x.com/RepulsiveCoder" className="connect-btn" target='_blank'>Connect <LinkExternalIcon width="18px" height="16px" /></a>
                        </div>
                    </>}
                    enableForMobile={true}
                >
                    <a href="https://x.com/RepulsiveCoder" title="Abdullah Ibne Alam - X" target="_blank" rel="noreferrer" className="x" onClick={(e) => { if (isMobile) { e.preventDefault(); } }}>
                        <XIcon />
                    </a>
                </RadixTooltip>
                <RadixTooltip
                    title={<>
                        <div className="social-cards">
                            <img src='/media/AbdullahIbneAlam.webp' alt="Abdullah Ibne Alam"  />
                            <h1>RepulsiveCoder</h1>
                            <div className="top-repos">
                                <Link className="repo" href="https://www.npmjs.com/package/react-lite-float-inputs" target="_blank">
                                    <h3>react-lite-float-inputs</h3>
                                    <p>npm install react-lite-float-inputs</p>
                                </Link>
                                <Link className="repo" href="https://www.npmjs.com/package/react-animated-text-writer" target="_blank">
                                    <h3>react-animated-text-writer</h3>
                                    <p>npm install react-animated-text-writer</p>
                                </Link>
                                <Link className="repo" href="https://www.npmjs.com/package/react-carousel-photo-gallery" target="_blank">
                                    <h3>react-carousel-photo-gallery</h3>
                                    <p>npm install react-carousel-photo-gallery</p>
                                </Link>
                            </div>
                            <a href="https://www.npmjs.com/~repulsivecoder" className="connect-btn" target='_blank'>Connect <LinkExternalIcon width="18px" height="16px" /></a>
                        </div>
                    </>}
                    enableForMobile={true}
                >
                    <a href="https://www.npmjs.com/~repulsivecoder" title="Abdullah Ibne Alam - NPM" target="_blank" rel="noreferrer" className="npm" onClick={(e) => { if (isMobile) { e.preventDefault(); } }}>
                        <NpmIcon />
                    </a>
                </RadixTooltip>
                <RadixTooltip
                    title={<>
                        <div className="social-cards">
                            <img src='/media/RepulsiveCoder.webp' alt="Abdullah Ibne Alam"  />
                            <h1>RepulsiveCoder</h1>
                            <p className="title">Member Since: 28 Feb 2021</p>
                            <a href="https://discordapp.com/users/815521363158368298" className="connect-btn" target='_blank'>Connect <LinkExternalIcon width="18px" height="16px" /></a>
                        </div>
                    </>}
                    enableForMobile={true}
                >
                    <a href="https://discordapp.com/users/815521363158368298" title="Abdullah Ibne Alam - Discord" target="_blank" rel="noreferrer" className="discord" onClick={(e) => { if (isMobile) { e.preventDefault(); } }}>
                        <DiscordIcon />
                    </a>
                </RadixTooltip>
            </div>
            <span className="privacyterms">
                <Link href="/toc.html">Terms and Conditions</Link>
                &nbsp;
                <span style={{ color: 'var(--muted-color)' }}>|</span>
                &nbsp;
                <Link href="/privacy.html">Privacy Policy</Link>
                {rssFeeds.includes(pathname) ? (
                    <>
                    &nbsp;
                    <span style={{ color: 'var(--muted-color)' }}>|</span>
                    &nbsp;
                    <Link href={`/${pathname.replace('/', '').split('/')[0]}/rss.xml`}>RSS Feed</Link>
                    </>
                ) : (null)
                }
                &nbsp;
                <span style={{ color: 'var(--muted-color)' }}>|</span>
                &nbsp;
                <Link href="/contact">Contact</Link>
			</span>
            <p> &copy; {startYear} - {new Date().getFullYear()} <Link href={`/repulsivecoder`}>{hostname}</Link></p>
        </div>
    );
}

export default Footer;